<template>
  <section class="section">
    <modal-fade />
    <sidenav />
    <ok-modal />
    <demo-header-text />
    <claro-header />
    <slot />
  </section>
</template>

<script>
import OkModal from './modals/OkModal';
import ModalFade from './modals/ModalFade';
import Sidenav from './Sidenav';
import ClaroHeader from './Header';
import DemoHeaderText from './DemoHeaderText';

export default {
  name: 'ClaroSection',
  components: {
    OkModal,
    Sidenav,
    ModalFade,
    ClaroHeader,
    DemoHeaderText
  }
};
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/components/ClaroSection.vue